<!--限制消费令详情-->
<template>
  <div class="legal-proceedings" :style="'min-height:'+heightH+'px'">
    <header-index/>
    <div class="legal-proceedings-content">
      <div class="basic-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="back">企业详情</a></el-breadcrumb-item>
          <el-breadcrumb-item>限制消费令详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="legal-proceedings-details">
        <el-col :span="24" class="title" v-html="documentTitle"/>
        <el-col :span="24" class="small-title">限令正文</el-col>
        <el-col :span="24" class="content" v-html="documentText"/>
      </el-row>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import {getConsumptionRestrictionOrderDetails} from "@/api/enterpriseDetailsApi";
import HeaderIndex from "@/components/header/headerIndex";
import cityJson from "@/static/cityJson.json";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
export default {
  name: "legalProceedingsDetail",
  components: {Hang, Home_footer, HeaderIndex},
  data() {
    return {
      documentTitle: '',
      documentText: '',
      cityList:{},
      id: '',
      /*公司id*/
      corpId: 0,
      heightH: document.documentElement.clientHeight,
    }
  },
  methods: {
    initHtml() {
      getConsumptionRestrictionOrderDetails({'id': this.$route.query.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          if (res.content != '') {
            this.documentTitle = '<div>' + res.content.courtConsumptionOrder + '</div><div>限制消费令</div>';
            if (res.content.consumptionOrderConten != '') {
              // let artical = res.content.consumptionOrderConten.split(":")
              this.documentText = '<div style="color: #333333;font-size: 14pt;line-height: 35px;">' + res.content.consumptionOrderConten + '<br/>'
            }
          }
        }
      })
    },
    back(){
      window.history.back()
    }
  },
  mounted() {
    this.corpId = this.$route.query.corpId;
    this.id = this.$route.query.id;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    this.initHtml();
  }
}
</script>
<style scoped>
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__inner a,
.legal-proceedings >>> .legal-proceedings-content .basic-details-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.legal-proceedings {
  background: #ECEEF5;
  /*企业基本信息css样式*/
  .legal-proceedings-content {
    padding: 10px 18% 10px;
    background: #ECEEF5;
    min-width: 76rem;
    .legal-proceedings-details {
      overflow: auto;
      margin-top: 10px;
      .title {
        padding: 40px;
        text-align: center;
        font-size: 24px;
      }

      .small-title {
        padding: 0px 40px 25px;
        font-size: 14pt;
        font-weight: bold;
      }

      .content {
        padding: 0px 40px 25px;
      }
    }

    .legal-proceedings-details::-webkit-scrollbar {
      width: 4px;
    }

    .legal-proceedings-details::-webkit-scrollbar-thumb {
      height: 8px;
      border-radius: 8px;
      background-color: #999999;
    }
  }
}
</style>